import { useEffect, useMemo } from "react";

import { useLoadFinderStore } from "@/state/loadFinderStore";
import { mergePrefills } from "@/state/strategy/mergePrefills";

export const useStrategyPrefills = (truckId) => {
  const fetchGlobalPrefill = useLoadFinderStore((s) => s.fetchGlobalPrefill);
  const fetchTruckPrefill = useLoadFinderStore((s) => s.fetchTruckPrefill);

  const globalPrefill = useLoadFinderStore((s) => (truckId != null ? (s.strategy.globalPrefill[truckId] ?? null) : null));
  const globalPrefillLoaded = useLoadFinderStore((s) => (truckId != null ? !!s.strategy.globalPrefillLoaded[truckId] : false));
  const truckPrefill = useLoadFinderStore((s) => (truckId != null ? (s.strategy.truckPrefill[truckId] ?? null) : null));
  const truckPrefillLoaded = useLoadFinderStore((s) => (truckId != null ? !!s.strategy.truckPrefillLoaded[truckId] : false));

  useEffect(() => {
    if (truckId == null) return;
    fetchGlobalPrefill(truckId);
    fetchTruckPrefill(truckId);
  }, [truckId, fetchGlobalPrefill, fetchTruckPrefill]);

  const mergedTruckPrefill = useMemo(() => mergePrefills(truckPrefill, globalPrefill), [truckPrefill, globalPrefill]);

  const prefillReady = truckId != null && globalPrefillLoaded && truckPrefillLoaded;

  return { truckPrefill, globalPrefill, mergedTruckPrefill, prefillReady };
};
